var ProductPage = {};

ProductPage.product = {};

ProductPage.init = function () {
  var pageEl = $('[data-product-id]');
  if (!pageEl.length) {
    return;
  }
  ProductPage.product._id = pageEl.attr("data-product-id");
  ProductPage.product.version = pageEl.attr("data-product-version");
  ProductPage.initGallery();
  $('.open_tabs_link').click(function (evt) {
    evt.preventDefault();
    if ($(this.hash).parents('.item').hasClass('opened')) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 80
        }, 1000);
        return false;
      }
    } else {
      $(this.hash).click();
    }
  });
  $('#pokaz-wiecej-opcji').click(function (evt) {
    $('.options li').show();
    $(this).hide();
    $('#pokaz-mniej-opcji').show();
  });
  $('#pokaz-mniej-opcji').click(function (evt) {
    $('.options li').removeAttr('style');
    $(this).hide();
    $('#pokaz-wiecej-opcji').show();
  });
  $('#add-to-cart').click(ProductPage.addToCartClick);

  $('.notifyMe_open').click(function () {
    ProductNotifyModal.open(ProductPage.product);
  });

  if ($('#chooseSize').length) {
    ProductPage.product.isOneVesion = false;
    ProductPage.chooseSizeSelect = $('#chooseSize')
      .select2()
      .on('select2:select', function (e) {
        if (e.params.data) {
          ProductPage.versionChanged(e.params.data.id);
        }
      });
  } else {
    ProductPage.product.isOneVesion = true;
  }

  $('#zapytaj-o-produkt-form').submit(ProductPage.sendEnquiry);

  $('.engrave_modal_open').click(ProductPage.openEngraveModal);


  Fav.loadFavs(function (resp) {
    if (resp.favorites && resp.favorites.indexOf(ProductPage.product._id) >= 0) {
      $('.fav').hide();
      $('.unfav').show();
    }
  });


  pageEl.find('.fav').on("click", function (evt) {
    Fav.favProduct(ProductPage.product._id, function () {
      Fav.loadFavs();
      $('.fav').hide();
      $('.unfav').show();
    });
  });

  pageEl.find('.unfav').on("click", function (evt) {
    evt.preventDefault();
    Fav.unFavProduct(ProductPage.product._id, function () {
      Fav.loadFavs();
      $('.fav').show();
      $('.unfav').hide();
    });
  });

  $('#openAliorRaty').click(function () {
    ProductPage.openAliorRaty($(this).attr('data-price'), 12);
  });
  $('#openMbankRaty').click(function () {
    ProductPage.openMbankRaty($(this).attr('data-price'));
  });
  $('#openCARaty').click(function () {
    ProductPage.openCARaty($(this).attr('data-price'));
  });
};

ProductPage.openEngraveModal = function () {
  EngraveModal.loadModal(ProductPage.product, {
    onAddToCart: function (engraveItem) {
      Cart.addItems([ProductPage.getItem(), engraveItem])
    }
  })
};

ProductPage.sendEnquiry = function (evt) {
  evt.preventDefault();
  var form = document.forms.zapytajOProdukt;
  Forms.clearFormErrors(form);
  var errors = Forms.validateFields(form, ProductPage.enquiryFields);
  if (errors.length > 0) {
    return;
  }
  var formData = {
    name: form.username.value,
    email: form.email.value,
    message: form.message.value,
    subject: form.subject.value
  };
  jQuery.ajax({
    url: "/product/ask",
    method: "post",
    data: JSON.stringify(formData),
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      if (resp.success) {
        $('.form').hide();
        $('#success-message').removeClass('hidden');
      }
    }
  });
};

ProductPage.enquiryFields = [
  {name: "formName", required: true},
  {name: "formEmail", required: true},
  {name: "formMessage", required: true}
];

ProductPage.getItem = function () {
  if (!ProductPage.product.isOneVesion) {
    var version = ProductPage.chooseSizeSelect.val();
    if (!version) {
      throw new Error("versions not selected");
    }
    ProductPage.product.version = version;
  }
  return {
    type: "product",
    product: ProductPage.product._id,
    version: ProductPage.product.version,
    qty: 1
  }
};

ProductPage.versionChanged = function (versionId) {
  ProductPage.product.version = versionId;
};

ProductPage.initGallery = function () {
  // Single product slider
  var single_product_slider = new Swiper('.single_product_slider', {
    spaceBetween: 10,
    autoHeight: true,
    navigation: {
      nextEl: '.single_product_slider .swiper-button-next',
      prevEl: '.single_product_slider .swiper-button-prev',
    },
    pagination: {
      el: '.product_gallery .swiper-pagination',
      clickable: true
    },
    breakpoints: {
      992: {
        autoHeight: false
      }
    }
  });

  var single_product_slider_nav = new Swiper('.single_product_slider_nav', {
    slidesPerView: 5,
    spaceBetween: 10,
    centeredSlides: false,
    direction: 'vertical',
    allowTouchMove: false,
    slideToClickedSlide: true,
    breakpoints: {
      992: {
        direction: 'horizontal',
        slidesPerView: 6,
      }
    }
  });

  if ($('.single_product_slider_nav .swiper-slide').length < 5) {
    $('.single_product_slider_nav .swiper-wrapper').addClass('small');
  } else {
    $('.single_product_slider_nav .swiper-wrapper').removeClass('small');
  }

  single_product_slider.controller.control = single_product_slider_nav;
  single_product_slider_nav.controller.control = single_product_slider;

  single_product_slider.on('transitionEnd', function () {
    var realIndex = $('.single_product_slider .swiper-slide-active').attr('data-swiper-slide-index');
    $('.single_product_slider_nav  .swiper-slide a').removeClass('active');
    $('.single_product_slider_nav  .swiper-slide a[data-hash=' + realIndex + ']').addClass('active');
  });

  $('.single_product_slider_nav .swiper-slide a').each(function () {
    $('.single_product_slider_nav .swiper-slide a').click(function (e) {
      e.preventDefault();
      $('.single_product_slider_nav .swiper-slide a').removeClass('active');
      $(this).addClass('active');
      var id = parseInt($(this).attr("data-hash"));
      single_product_slider.slideTo(id);
    });
  });

  $(window).resize(function () {
    single_product_slider.update();
    single_product_slider_nav.update();
  });

  ProductPage.swiper_lightbox = new Swiper('#product_lightbox .swiper-container', {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '#product_lightbox .swiper-button-next',
      prevEl: '#product_lightbox .swiper-button-prev',
    },
    spaceBetween: 10
  });

  $('#product_lightbox').popup({
    onopen: function () {
      ProductPage.swiper_lightbox.update();
    }
  });
};

ProductPage.loadViewedProducts = function () {
  //todo:
};

ProductPage.loadSimilarProducts = function () {
  //todo:
};

ProductPage.addToCartClick = function () {
  Cart.addItems(ProductPage.getItem());
};

ProductPage.addToCartFromEngraverClick = function () {
  Cart.addItems({
    type: "product",
    product: ProductPage.product._id,
    version: ProductPage.product.version,
    qty: 1
  }, {
    type: "engrave",
    product: ProductPage.product._id,
    qty: 1,
    font: "",
    text: ""
  });
};

ProductPage.showGalleryZoomModal = function () {

};

ProductPage.openAliorRaty = function (cash, period) {
  window.open('https://ssl.dotpay.pl/erata/alior/kalkulator?amount=' + cash + '&period=' + period, 'Alior Raty Kalkulator', 'width=655,height=510,directories=0,location=1,menubar=0,resizable=0,scrollbars=0,status=0,toolbar=0');
};

ProductPage.openMbankRaty = function (cash) {
  window.open('https://ssl.dotpay.pl/erata/mbank/kalkulator?kwota=' + cash, 'mBank Raty Kalkulator', 'width=800,height=600,directories=0,location=1,menubar=0,resizable=0,scrollbars=0,status=0,toolbar=0');
};

ProductPage.openCARaty = function (cash) {
  window.open('https://ewniosek.credit-agricole.pl/eWniosek/simulator.jsp?PARAM_TYPE=RAT&PARAM_PROFILE=PSP2002061&PARAM_CREDIT_AMOUNT=' + cash, 'CA Raty Kalkulator', 'width=800,height=600,directories=0,location=1,menubar=0,resizable=0,scrollbars=0,status=0,toolbar=0');
};

$(ProductPage.init);


